// Status labels
export const STATUS_PENDING = 'pending';
export const STATUS_NEXT = 'next';
export const STATUS_CANCELED = 'canceled';
export const STATUS_SOBRETURNO = 'sobreturno';

//Messages
export const API_ERROR_MESSAGE = 'Ha ocurrido un error';

// User Types

export const USER_TYPE_MEDIC = 'medic';
export const USER_TYPE_PATIENT = 'patient';
